import { render, staticRenderFns } from "./DeliveryRoutesPage.vue?vue&type=template&id=ca312134"
import script from "./DeliveryRoutesPage.vue?vue&type=script&lang=js"
export * from "./DeliveryRoutesPage.vue?vue&type=script&lang=js"
import style0 from "./DeliveryRoutesPage.vue?vue&type=style&index=0&id=ca312134&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports